/** Puestos que no pueden ver ni operar la nómina administrativa (solo teachers / propia). */
export const PUESTOS_SIN_NOMINA_ADMIN = [52, 82]

export function puedeVerNominaAdministrativa (usuario) {
  if (!usuario || usuario.idpuesto == null) return true
  return !PUESTOS_SIN_NOMINA_ADMIN.includes(Number(usuario.idpuesto))
}
